import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import { CadastroTermosPage } from '../features/workspace/termos/CadastroTermosPage';

export const Route = createFileRoute('/w/$workspaceId/settings/termos')({
  component: TermosSettingsRoute,
});

function TermosSettingsRoute() {
  const { workspaceId } = Route.useParams();
  const { data: workspace } = useQuery({
    queryKey: ['workspaces', workspaceId],
    queryFn: async () => {
      const response = await api.get(`/workspaces/${workspaceId}`);
      return response.data.data;
    },
  });

  return (
    <CadastroTermosPage
      workspaceId={workspaceId}
      workspaceName={workspace?.name}
    />
  );
}
